import React from "react";
import { useI18n } from "@/lib/i18n";

const STYLES = {
  pending: { bg: "#eef1f5", color: "#5b6b82", border: "#d3dae4" },
  in_progress: { bg: "#fdf2e2", color: "#b45309", border: "#f0d3a3" },
  done: { bg: "#e8f2e9", color: "#2e7d32", border: "#bfe0c2" },
  blocked: { bg: "#f9e7e9", color: "#9c1e2b", border: "#eec2c7" },
  skipped: { bg: "#eceef2", color: "#64748b", border: "#d3dae4" },
  in_produzione: { bg: "#eaf0fb", color: "#2c4a89", border: "#c3d3ef" },
  completata: { bg: "#e8f2e9", color: "#2e7d32", border: "#bfe0c2" },
  bloccata: { bg: "#f9e7e9", color: "#9c1e2b", border: "#eec2c7" },
  a_rischio: { bg: "#fdf2e2", color: "#b45309", border: "#f0d3a3" },
  pronta: { bg: "#e6f4f1", color: "#0f766e", border: "#b9e0d9" },
  alta: { bg: "#f9e7e9", color: "#9c1e2b", border: "#eec2c7" },
  normale: { bg: "#eaf0fb", color: "#2c4a89", border: "#c3d3ef" },
  bassa: { bg: "#eef1f5", color: "#5b6b82", border: "#d3dae4" },
  libero: { bg: "#f3f5f8", color: "#7a879a", border: "#dde3ec" },
  nessuna: { bg: "#f3f5f8", color: "#9aa7b8", border: "#e5e9f0" },
  scaduto: { bg: "#f9e0e3", color: "#8a1622", border: "#e6b3ba" },
  urgente: { bg: "#fdf2e2", color: "#b45309", border: "#f0d3a3" },
  attenzione: { bg: "#fbf6e6", color: "#8a6d15", border: "#eadfb0" },
  pianificare: { bg: "#eaf0fb", color: "#2c4a89", border: "#c3d3ef" },
};

export default function StatusBadge({ value, testid }) {
  const { t } = useI18n();
  const s = STYLES[value] || STYLES.pending;
  return (
    <span
      data-testid={testid}
      className="font-mono text-[11px] uppercase tracking-wider px-2 py-1 border rounded-[3px] whitespace-nowrap"
      style={{ background: s.bg, color: s.color, borderColor: s.border }}
    >
      {t(value)}
    </span>
  );
}
